import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "BytePro";
const sub = "SecurityProfile";

class SecurityProfileService {
  getSecurityProfiles() {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getSecurityProfile(securityProfileId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${securityProfileId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new SecurityProfileService();
